import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiUsers, FiRefreshCw } = FiIcons;

export default function Trust() {
  const points = [
    {
      icon: FiShield,
      title: 'Regulated Platform',
      description: 'Fully compliant & secure trading environment',
    },
    {
      icon: FiUsers,
      title: '10M+ Global Users',
      description: 'Trusted by millions of investors worldwide',
    },
    {
      icon: FiRefreshCw,
      title: 'Instant Withdrawals',
      description: 'Your money is yours. Withdraw at any time.',
    },
  ];

  return (
    <section className="py-12 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {points.map((point, index) => (
            <div key={index} className="flex items-start gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors">
              <div className="flex-shrink-0 w-12 h-12 bg-emerald-50 text-emerald-600 rounded-lg flex items-center justify-center">
                <SafeIcon icon={point.icon} className="text-2xl" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900">{point.title}</h3>
                <p className="text-sm text-gray-500 mt-1">{point.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}